import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: calc(100vh - 40px);
  min-width: 0;

  .contentContainer {
    flex: 1 1 0;
    width: 0;
    /* permite a coluna encolher abaixo da largura intrinseca da tabela;
       sem isso a tabela larga empurra o layout e vaza a direita (ex: zoom 125%) */
    min-width: 0;
  }

  .dashboardContent {
    background-color: ${({ theme }) => theme.colors.background.gray};

    height: 100%;
    width: 100%;
    padding: 40px;

    overflow-y: scroll;

    @media (max-width: 900px) {
      padding: 24px 20px;
    }
  }

  @media (max-width: 700px) {
    height: auto;
    min-height: calc(100vh - 40px);

    .dashboardContent {
      height: auto;
      min-height: calc(100vh - 100px);
      padding: 16px 12px;
      overflow: visible;
    }
  }

  @media (max-width: 600px) {
    display: block;
    width: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    padding-bottom: calc(64px + env(safe-area-inset-bottom));

    .contentContainer {
      flex: initial;
      width: 100%;
    }

    .dashboardContent {
      min-height: 0;
      padding: 16px 12px;
    }
  }
`;
